export default __webpack_public_path__ + "static/media/Vazir.e16b14e5.eot";